// API Configuration
// Centralized configuration for API endpoints and settings

export const API_CONFIG = {
    // Backend API URL - can be overridden by environment variable
    // BASE_URL: 'http://localhost:3000',
    BASE_URL: import.meta.env.VITE_API_URL || 'https://api.kioskservice.club',

    // API endpoints
    ENDPOINTS: {
        // Authentication
        AUTH: {
            SEND_CODE: '/auth/send-code',
            LOGIN: '/auth/login',
            REGISTER: '/auth/register',
            VERIFY_EMAIL: '/auth/verify-email',
            REFRESH_TOKEN: '/auth/refresh-token',
            LOGOUT: '/auth/logout',
            PROFILE: '/auth/profile',
            TIER: '/auth/tier',
            PHONE_SEND_OTP: '/auth/phone/send-otp',
            PHONE_LOGIN: '/auth/phone/login'
        },

        // User Management
        USER: {
            PROFILE: '/users/profile',
            UPDATE_PROFILE: '/users/profile',
            SESSIONS: '/users/sessions',
            REVOKE_SESSION: '/users/sessions',
            REVOKE_ALL_SESSIONS: '/users/sessions'
        },

        // Payment
        PAYMENT: {
            DEPOSIT: '/payment/deposit',
            WITHDRAWAL: '/payment/withdrawal',
            HISTORY: '/payment/history'
        },

        // System
        SYSTEM: {
            HEALTH: '/health'
        },

        // VFX Configuration
        VFX: {
            CONFIG: '/vfx-config'
        },

        // Kiosk
        KIOSK: {
            HEARTBEAT: '/kiosk/heartbeat',
            INFO: '/kiosk/info',
            CLIENT_VERSION: '/kiosk/client-version'
        }
    },

    // Request configuration
    REQUEST: {
        TIMEOUT: 30000, // 30 seconds
        RETRY_ATTEMPTS: 3,
        RETRY_DELAY: 1000 // 1 second
    },

    // Authentication
    AUTH: {
        TOKEN_STORAGE_KEY: 'accessToken',
        REFRESH_TOKEN_STORAGE_KEY: 'refreshToken',
        TOKEN_REFRESH_THRESHOLD: 5 * 60 * 1000 // 5 minutes before expiry
    },

    // Gamify Widget (Widget mode: tenantSlug + getUserToken)
    GAMIFY: {
        API_BASE_URL: import.meta.env.VITE_GAMIFY_API_BASE_URL || 'https://api.gamifyengine.com',
        TENANT_SLUG: import.meta.env.VITE_GAMIFY_TENANT_SLUG || 'your-tenant',
        FAB_POSITION: 'right-bottom' as const
    }
};

// Helper function to get full API URL
export const getApiUrl = (endpoint: string): string => {
    return `${API_CONFIG.BASE_URL}/api${endpoint}`;
};

// Helper function to get health check URL
export const getHealthUrl = (): string => {
    return `${API_CONFIG.BASE_URL}/health`;
};

// Environment detection
export const isDevelopment = import.meta.env.DEV;
export const isProduction = import.meta.env.PROD;

// Feature flags
export const FEATURE_FLAGS = {
    ENABLE_DEMO_MODE: import.meta.env.VITE_ENABLE_DEMO_MODE === 'true',
    ENABLE_SOUND_EFFECTS: import.meta.env.VITE_ENABLE_SOUND_EFFECTS !== 'false',
    ENABLE_ANIMATIONS: import.meta.env.VITE_ENABLE_ANIMATIONS !== 'false',
    ENABLE_DEBUG_LOGS: import.meta.env.VITE_DEBUG === 'true'
};

// Notification configuration
export const NOTIFICATION_CONFIG = {
    DURATION: {
        SUCCESS: parseInt(import.meta.env.VITE_NOTIFICATION_DURATION_SUCCESS || '5000'),
        ERROR: parseInt(import.meta.env.VITE_NOTIFICATION_DURATION_ERROR || '0'),
        WARNING: parseInt(import.meta.env.VITE_NOTIFICATION_DURATION_WARNING || '7000'),
        INFO: parseInt(import.meta.env.VITE_NOTIFICATION_DURATION_INFO || '4000')
    }
};
